import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Preparação",
  path: "/merenda/merpreparacao",
  name: "merpreparacao",
  component: () => import("@/views/merenda/merpreparacao/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.PREPARACAONOVO_MENU_1000200499],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Preparação",
  path: "/merenda/merpreparacao/cadastro/:id?",
  parent: "merpreparacao",
  name: "merpreparacao_create",
  component: () => import("@/views/merenda/merpreparacao/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.PREPARACAONOVO_MENU_1000200499],
  },
  goesToMenu: true,
 },
 {
  description: "Composição da Preparação",
  path: "/merenda/merpreparacao/composicao/:id",
  parent: "merpreparacao",
  name: "merpreparacao_composicao",
  component: () => import("@/views/merenda/merpreparacao/Composicao.vue"),
  meta: {
   permissions: [eTipoPermissao.PREPARACAONOVO_MENU_1000200499],
  },
  goesToMenu: true,
 },
 {
  description: "Ficha Técnica da Preparação",
  path: "/merenda/merpreparacao/fichatecnica/:id",
  parent: "merpreparacao",
  name: "merpreparacao_fichatecnica",
  component: () => import("@/views/merenda/merpreparacao/FichaTecnica.vue"),
  meta: {
   permissions: [eTipoPermissao.PREPARACAONOVO_MENU_1000200499],
  },
  goesToMenu: true,
 },
];
